const PROVIDER_CLICKOUTS = 'providerClickouts'

type ProviderClickouts = {
  providerSlug: string
  source: string
  timestamp: number
}

export async function storeProviderClickout(providerSlug: string) {
  const providerData: ProviderClickouts = {
    providerSlug,
    source: location.href,
    timestamp: Date.now(),
  }
  const storedData = (await storage.getValue<ProviderClickouts[]>(PROVIDER_CLICKOUTS)) || []
  const providerIndex = storedData.findIndex((item) => item.providerSlug === providerSlug)
  if (providerIndex > -1) {
    storedData.splice(providerIndex, 1)
  }
  storedData.push(providerData)
  await storage.setValue(PROVIDER_CLICKOUTS, storedData)
}

export async function getProviderClickouts() {
  return (await storage.getValue<ProviderClickouts[]>(PROVIDER_CLICKOUTS)) || []
}

export async function clearProviderClickouts() {
  await storage.removeValue(PROVIDER_CLICKOUTS)
}
